var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.425 8.34167L10.5083 20.2583C10.2917 20.475 10.075 20.5833 9.75 20.5833C9.425 20.5833 9.20833 20.475 8.99167 20.2583L3.575 14.8417C3.14167 14.4083 3.14167 13.7583 3.575 13.325C4.00833 12.8917 4.65833 12.8917 5.09167 13.325L9.75 17.9833L20.9083 6.825C21.3417 6.39167 21.9917 6.39167 22.425 6.825C22.8583 7.25833 22.8583 7.90833 22.425 8.34167Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 20,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.425 8.34167L10.5083 20.2583C10.2917 20.475 10.075 20.5833 9.75 20.5833C9.425 20.5833 9.20833 20.475 8.99167 20.2583L3.575 14.8417C3.14167 14.4083 3.14167 13.7583 3.575 13.325C4.00833 12.8917 4.65833 12.8917 5.09167 13.325L9.75 17.9833L20.9083 6.825C21.3417 6.39167 21.9917 6.39167 22.425 6.825C22.8583 7.25833 22.8583 7.90833 22.425 8.34167Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.41bcf52e86c6f643172309acfa4f1a7c.svg";
export { ForwardRef as ReactComponent };